import { useTranslation } from "react-i18next"

import { useBikeStoreProcess } from "hooks"

type BikeDescriptionProps = {
	className?: string
	toggleReadOnly?: () => void
}

export const BikeDescription: React.FC<BikeDescriptionProps> = ({
	className = "",
	toggleReadOnly = null,
}) => {
	const { bikeProcessState } = useBikeStoreProcess()
	const { currentBike: bike } = bikeProcessState
	const { t } = useTranslation()

	return (
		<div className={`w-full ${className}`}>
			<div className="c-card p-5 md:p-12 mb-5">
				<h2 className="c-h2 font-semibold mb-7 uppercase">
					{t("description_title", { ns: "bike" })}
				</h2>
				<p className="mb-2">
					<span className="text-black font-bold">{t("brand", { ns: "bike" })} : </span>
					<span className="text-primary ml-2">{bike?.brand}</span>
				</p>
				<p className="mb-2">
					<span className="text-black font-bold">{t("model", { ns: "bike" })} : </span>
					<span className="text-primary ml-2">{bike?.model}</span>
				</p>
				<p className="mb-2">
					<span className="text-black font-bold">{t("type", { ns: "bike" })} : </span>
					<span className="text-primary ml-2">{t(bike?.gear_type)}</span>
				</p>
				<p className="mb-2">
					<span className="text-black font-bold">{t("color", { ns: "bike" })} : </span>
					<span className="text-primary ml-2">{bike?.color}</span>
				</p>
				<p className="mb-7">
					<span className="text-black font-bold">
						{t("label_vae_short", { ns: "bike" })} :{" "}
					</span>
					<span className="text-primary ml-2">
						{bike?.isVAE === "true"
							? t("label_vae_true", { ns: "bike" })
							: t("label_vae_false", { ns: "bike" })}
					</span>
				</p>
				<p className="mb-2">
					<span className="text-black font-bold">{t("serial", { ns: "bike" })} : </span>
					<span className="text-primary ml-2">{bike?.frame_serial_number}</span>
				</p>

				{bike?.isVAE === "true" && (
					<>
						<p className="mb-2">
							<span className="text-black font-bold">
								{t("serial_engine", { ns: "bike" })} :{" "}
							</span>
							<span className="text-primary ml-2">{bike?.engine_serial_number}</span>
						</p>
						<p className="mb-2">
							<span className="text-black font-bold">
								{t("serial_battery", { ns: "bike" })} :{" "}
							</span>
							<span className="text-primary ml-2">{bike?.battery_serial_number}</span>
						</p>
					</>
				)}
				{toggleReadOnly && (
					<button className="c-btn c-btn--primary px-5 ml-auto" onClick={toggleReadOnly}>
						{t("global.update")}
					</button>
				)}
			</div>
		</div>
	)
}
